import { render, staticRenderFns } from "./AccordionItemComponent.vue?vue&type=template&id=12d71250&scoped=true"
import script from "./AccordionItemComponent.vue?vue&type=script&lang=js"
export * from "./AccordionItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d71250",
  null
  
)

export default component.exports